import * as React from "react";
import styled from "styled-components";
import { List } from "@radix-ui/react-tabs";
const _TabsControls = ({ children, className, asChild = false, ...htmlProps }) => {
    return (React.createElement(List, { asChild: asChild, className: className, ...htmlProps }, children));
};
_TabsControls.defaultProps = {
    "data-testid": "controls",
};
export const TabsControls = styled(_TabsControls) ``;
//# sourceMappingURL=TabsControls.js.map